export default "__VITE_ASSET__PmwffPj$__"